import { motion, type HTMLMotionProps } from 'motion/react'
import styles from './TouchButton.module.css'

interface TouchButtonProps extends Omit<HTMLMotionProps<'button'>, 'style'> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost'
  size?: 'normal' | 'large' | 'xlarge'
}

export function TouchButton({
  variant = 'primary',
  size = 'normal',
  type,
  className,
  children,
  ...props
}: TouchButtonProps) {
  // Default `type="button"` para que un click NO dispare submit del form
  // contenedor. Sin este default, montar `<TouchButton onClick=...>` adentro
  // de un `<form>` (ej: `AssetUploader` dentro del form del evento) submitea
  // el form padre al hacer click — bug recurrente. Los botones que sí deben
  // submitear pasan `type="submit"` explícito (PairingByCodeFlow, NameInputScreen).
  return (
    <motion.button
      type={type ?? 'button'}
      whileTap={{ scale: 0.95 }}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      className={`${styles.button} ${styles[variant]} ${styles[size]} ${className || ''}`}
      {...props}
    >
      {children}
    </motion.button>
  )
}
